import Button from "../../components/button";
import { Table } from "../../components/ui/table";
import AddIcon from "../../components/icons/add-icon";
import FilterIcon from "../../components/icons/filter-icon";
import Popover from "@mui/material/Popover";
import { useEffect, useMemo, useState } from "react";
import ViewIcon from "../../components/icons/view-icon";
import DeleteIcon from "../../components/icons/delete-icon";
import ConfirmationCard from "../../components/ui/confirmation-card";
import Modal from "../../components/ui/modal";
import CardDetail from "../../components/cardDetail/cardDetail";
import {
  getCards,
  getOffering,
  getPriceGroup,
  getTotalOffering,
} from "src/firebase/admin.js";
import { deleteDoc, doc } from "firebase/firestore";
import { handleToastMessage } from "src/js/handleToastMessage";
import { db } from "src/firebase/firebase";
import { useTranslation } from "react-i18next";
import { dateSorting } from "src/js/sorting";
import { Pagination } from "@mui/material";
import OverlayLoader from "../../components/overlayLoader";
import AddPriceGroup from "../../components/addPriceGroup/addPriceGroup";
import CreateOffering from "../../components/createOffering/CreateOffering";

const pageSize = 200;

const SupplierRateInfo = () => {
  const [activeDeletedId, setActiveDeletedId] = useState<string>("");
  const [activeCardDetail, setActiveCardDetail] = useState(null);
  const [cardList, setCardList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation(["home"]);
  const [totalCards, setTotalCards] = useState<number>(0);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [searchText, setSearchText] = useState<string>("");
  const [createOffering, setCreateOffering] = useState(null);
  const [showRate, setShowRate] = useState(false);

  useEffect(() => {
    getCardList();
  }, [currentPage, searchText]);

  const getCardList = async () => {
    setIsLoading(true);
    const _data = await localStorage.getItem("account");
    const data = JSON.parse(_data);

    let result: any = await getTotalOffering(data?.priceGroup);

    setIsLoading(false);
    setCardList(result);
  };

  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setCurrentPage(page);
  };

  const columns = [
    {
      title: (
        <div className="pl-1 flex justify-between items-center">
          <span>{t("Offering Name")}</span>
        </div>
      ),
      dataIndex: "name",
      key: "name",
      width: 100,
      render: (cardNo: string) => <div>{cardNo}</div>,
    },

    {
      title: (
        <div className="pl-1 flex justify-between items-center">
          <span>{t("Denomination")}</span>
        </div>
      ),
      dataIndex: "name",
      key: "name",
      width: 100,
      render: (cardNo: string, row) => (
        <div>
          {row.denominationMin} - {row.denominationMax}
        </div>
      ),
    },
    {
      title: (
        <div className="pl-1 flex justify-between items-center">
          <span>{t("Rate")}</span>
        </div>
      ),
      dataIndex: "name",
      key: "name",
      width: 100,
      render: (cardNo: string, row) => <div>{row.rate}</div>,
    },
    {
      title: (
        <div className="pl-1 flex justify-between items-center">
          <span>{t("Price Group Name")}</span>
        </div>
      ),
      dataIndex: "name",
      key: "name",
      width: 100,
      render: (cardNo: string, row) => {
        return <div>{row.priceGroup.name}</div>;
      },
    },
  ];
  const handleDelete = () => {
    const docRef = doc(db, "Cards", activeDeletedId);
    deleteDoc(docRef).then((res) => {
      handleToastMessage("success", "Delete card successfully");
      setActiveDeletedId("");
      getCardList();
    });
  };

  return (
    <div className="p-5">
      <div className="flex justify-between items-center mb-3">
        <h2 className="text-xl text-darkBlack font-semibold">
          {t("Rate Info")}
        </h2>
      </div>
      <div className="p-4 bg-white">
        {isLoading && <OverlayLoader />}
        <Table
          tableLayout="fixed"
          columns={columns as any}
          emptyText={t("No data found")}
          data={cardList}
          rowKey="id"
          scroll={{ x: 400 }}
          sticky={true}
          className="matrix"
          onHeaderRow={() => ({
            className: "header-title",
          })}
        />
        {/* <Pagination
          className="w-full mt-10"
          count={Math.ceil(totalCards / pageSize)}
          onChange={handlePageChange}
        /> */}
      </div>
      <Modal
        open={activeDeletedId ? true : false}
        onClose={() => setActiveDeletedId("")}
      >
        <ConfirmationCard
          title={t("Delete This Item?")}
          onCancel={() => setActiveDeletedId("")}
          onDelete={handleDelete}
          description={t(
            "Are you sure about deleting this card? This cannot be undone."
          )}
        />
      </Modal>
      <Modal
        open={activeCardDetail ? true : false}
        onClose={() => setActiveCardDetail(null)}
        modalClass="w-full"
      >
        <CardDetail detail={activeCardDetail} />
      </Modal>
    </div>
  );
};
export default SupplierRateInfo;
